var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Messages/card/double"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.00004 3.5H24.5C25.7887 3.5 26.8334 4.54467 26.8334 5.83333V19.8333M7.00004 11.6667H10.5M7.00004 15.1667H10.5M7.00004 18.6667H10.5M6.06671 23.3333H19.6C20.9068 23.3333 21.5602 23.3333 22.0594 23.079C22.4984 22.8553 22.8554 22.4984 23.0791 22.0593C23.3334 21.5602 23.3334 20.9068 23.3334 19.6V10.7333C23.3334 9.42654 23.3334 8.77315 23.0791 8.27402C22.8554 7.83498 22.4984 7.47802 22.0594 7.25432C21.5602 7 20.9068 7 19.6 7H6.06671C4.75992 7 4.10652 7 3.6074 7.25432C3.16835 7.47802 2.8114 7.83498 2.58769 8.27402C2.33337 8.77315 2.33337 9.42654 2.33337 10.7333V19.6C2.33337 20.9068 2.33337 21.5602 2.58769 22.0593C2.8114 22.4984 3.16835 22.8553 3.6074 23.079C4.10652 23.3333 4.75992 23.3333 6.06671 23.3333ZM14.9334 16.3333H17.7334C18.0601 16.3333 18.2234 16.3333 18.3482 16.2698C18.458 16.2138 18.5472 16.1246 18.6031 16.0148C18.6667 15.89 18.6667 15.7267 18.6667 15.4V12.6C18.6667 12.2733 18.6667 12.11 18.6031 11.9852C18.5472 11.8754 18.458 11.7862 18.3482 11.7302C18.2234 11.6667 18.0601 11.6667 17.7334 11.6667H14.9334C14.6067 11.6667 14.4433 11.6667 14.3185 11.7302C14.2088 11.7862 14.1195 11.8754 14.0636 11.9852C14 12.11 14 12.2733 14 12.6V15.4C14 15.7267 14 15.89 14.0636 16.0148C14.1195 16.1246 14.2088 16.2138 14.3185 16.2698C14.4433 16.3333 14.6067 16.3333 14.9334 16.3333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDouble);
export default __webpack_public_path__ + "static/media/double.72c0753795d6be2cc0c966a2b0a40bc1.svg";
export { ForwardRef as ReactComponent };